import React from "react";
import "./style.css";
import Img2 from "../../images/multi.png";
function LastComponent() {
  return (
    <div className="container  mainlast ">
      <div className="main-div   ">
        <div className="row justify-content-between">
          <div className="col-lg-6 col-md-5 d-flex justify-content-center align-items-center flex-column">
            <div>
              <p className="text-white  content-div">
                Share your contact <br />
                anytime, anywhere
              </p>
              <p className="h3  text-white p-div">
                With Share My Details, send your
                <br /> profile to anyone in seconds and
                <br />
                carry on with your day!
              </p>
              <div className="btndiv mt-5">
                <button className="btn-lg button ">Get the app</button>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-5 d-flex justify-content-center align-items-center">
            <img className="img-fluid imglast" src={Img2} alt="" />
          </div>
          {/* <img className="img-fluid img3" src={img3} />
        <img className="img-fluid img1" src={img1} /> */}
        </div>
      </div>
    </div>
  );
}

export default LastComponent;
